import _ from 'lodash'
import React from 'react'

import apis from 'browser/app/models/apis'
import type { Entity } from 'shared-libs/models/entity'
import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import { LoadingSpinner } from 'browser/components/atomic-elements/atoms/loading-spinner/loading-spinner'
import { Section } from 'browser/components/atomic-elements/atoms/section/section'
import {
  filterCustomer,
  filterLoad,
  filterLoadStatus,
} from 'browser/components/atomic-elements/organisms/analytics/data-set'
import { EntityDataSource } from 'browser/components/atomic-elements/organisms/entity/entity-data-source'

import { AnalyticsBlock } from './analytics-block'

/**
 * @uiComponent
 */
interface ICustomerAnalyticsSectionProps extends IBaseProps {
  entity: any
}

interface ICustomerAnalyticsSectionState {
  dataSets: any
  filters: any[]
  isLoading: boolean
  tabs: any
}

export class CustomerAnalyticsSection extends React.Component<
  ICustomerAnalyticsSectionProps,
  ICustomerAnalyticsSectionState
> {
  private store: any

  constructor(props: ICustomerAnalyticsSectionProps) {
    super(props)
    this.store = apis.getStore()
    this.state = {
      dataSets: [],
      filters: this.getFilters(props.entity),
      isLoading: true,
      tabs: [],
    }
  }

  public componentDidMount() {
    const { filters } = this.state
    this.store.findRecord('52031656-7d48-4b50-b051-d166fbe72b7b').then((result: Entity) => {
      const dataSets = this.createDataSets(result.content.view.state.queries, filters)
      _.forEach(dataSets, (dataSet: any) => dataSet.find())
      this.setState({
        dataSets,
        isLoading: true,
        tabs: result.content.view.state.tabs,
      })
    })
  }

  public UNSAFE_componentWillReceiveProps(nextProps: ICustomerAnalyticsSectionProps) {
    const { dataSets } = this.state
    if (this.props.entity !== nextProps.entity) {
      this.setState({ isLoading: true })
      _.forEach(dataSets, (dataSet: any) => {
        dataSet.handleFiltersChange(this.getFilters(nextProps.entity))
      })
    }
  }

  public componentWillUnmount() {
    const { dataSets } = this.state
    _.forEach(dataSets, (dataSet) => dataSet.dispose())
  }

  public render() {
    const { dataSets, filters, isLoading, tabs } = this.state
    return (
      <Section title="Customer Analytics">
        <AnalyticsBlock dataSets={dataSets} filters={filters} isLoading={isLoading} tabs={tabs} />
      </Section>
    )
  }

  private getFilters(entity: Pick<Entity, 'uniqueId'>) {
    return [filterLoad(), filterLoadStatus('Settling'), filterCustomer(entity.uniqueId)]
  }

  private createDataSets(dataSets: Record<string, unknown>, filters: unknown[]) {
    const results: Record<string, EntityDataSource> = {}
    _.forEach(dataSets, (dataSet, key) => {
      results[key] = new EntityDataSource(dataSet)
        .setFilters(filters)
        .setOnChange(this.handleDataSetChange)
    })
    return results
  }

  private handleDataSetChange = (dataSet: unknown) => {
    const { dataSets } = this.state
    const isLoading = _.some(dataSets, { isLoading: true })
    this.setState({ isLoading })
  }
}
